export const APP_NAME = '生活保護給付管理ツール' as const

export const STORAGE_KEYS = {
  COLUMN_MAPPING: 'ijdiRecipientCsvColumnMappingV1',
} as const

export const API_EVENTS = {
  UNAUTHORIZED: 'pams:unauthorized',
  SESSION_INVALIDATED: 'pams:session-invalidated',
  API_ERROR: 'pams:api-error',
  MAINTENANCE: 'pams:maintenance',
} as const

export const PAGINATION = {
  DEFAULT_PAGE: 0,
  DEFAULT_SIZE: 20,
  MAX_SIZE: 100,
  SIZE_OPTIONS: [10, 20, 50, 100] as readonly number[],
} as const

export const DATE_FORMATS = {
  DISPLAY: 'YYYY/MM/DD',
  DISPLAY_WITH_TIME: 'YYYY/MM/DD HH:mm',
  ISO: 'YYYY-MM-DD',
  API_DATETIME: 'YYYY-MM-DDTHH:mm:ss',
} as const
